import React from 'react';
import { site } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
export function FinalCta() {
  return <section id="try-a-class" aria-labelledby="final-title" className="on-dark bg-ink py-20 text-white lg:py-24" data-id="element-103" data-mp="2pe59faq39sxk">
      <Container className="grid items-center gap-10 md:grid-cols-12 md:gap-12" data-id="element-104" data-mp="2khes6k2jsrak">
        <div className="flex justify-center md:col-span-4 md:justify-start" data-id="element-105" data-mp="1wrkksi0zzuxp">
          <img src={site.logo} alt="Bates Taekwondo logo" className="h-[220px] w-auto sm:h-[260px] lg:h-[300px]" loading="lazy" data-id="element-106" data-mp="1rry767h9ccod" />
        </div>
        <Reveal className="md:col-span-8" data-id="element-107" data-mp="21p2kdht4kxt1">
          <h2 id="final-title" className="text-balance font-display text-[2.8rem] font-bold uppercase leading-[0.92] sm:text-[3.6rem] lg:text-[4.4rem]" data-id="element-108" data-mp="21o148yx95l4g">
            Your first class is free. <span className="text-brand" data-id="element-109" data-mp="18yu8g7p6n9mw">Come see how it feels.</span>
          </h2>
          <p className="text-pretty mt-6 max-w-[36rem] text-lg leading-relaxed text-white/80" data-id="element-110" data-mp="3nbhqhaarqjxx">
            Bring your questions, meet the Bates Taekwondo family, and find the class that fits. Kids, teens and adults
            are all welcome.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-111" data-mp="4yjqj3dz7r3r">
            <ButtonLink href="#first-class" data-id="element-112" data-mp="4zupmpwh8aoj">Book a Free Trial Class</ButtonLink>
            <ButtonLink href={site.phoneHref} variant="outlineLight" data-id="element-113" data-mp="34eye8c4o4fx5">
              Call {site.phoneDisplay}
            </ButtonLink>
          </div>
        </Reveal>
      </Container>
    </section>;
}